import { useCallback, useEffect, useState } from "react";
import financeApiService from "../../../../services/financeApiService";
import financeV2Adapters from "../../../../adapters/financeV2Adapters";

// LS-678 — la « référence » d'une ligne de devis est un libellé véhicule, non
// unique au sein d'un dossier : indexer par référence faisait « baver » le
// statut d'une demande sur toutes les lignes homonymes. L'index est par uuid
// de devis ; la référence ne sert que de repli tant que l'API ne renvoie pas
// encore `devis_uuids` (fenêtre de déploiement).
// En cas de devis présent dans plusieurs demandes, conserve le statut le plus
// avancé (valeur d'enum la plus haute : Transmis et signé > … > Brouillon).
export const construireDemandesParDevis = (items) => {
  const map = new Map();
  items.forEach((demande) => {
    const cles =
      demande.devisUuids && demande.devisUuids.length > 0
        ? demande.devisUuids
        : demande.devisReferences;
    cles.forEach((cle) => {
      const existing = map.get(cle);
      if (!existing || demande.statut.valeur > existing.statut) {
        map.set(cle, {
          demandeUuid: demande.uuid,
          statut: demande.statut.valeur,
          libelle: demande.statut.libelle,
        });
      }
    });
  });
  return map;
};

// Charge les demandes de financement d'un client et expose, par uuid de devis
// (repli : référence), la demande liée et son statut. Un seul appel par client.
const useDemandesParDevis = (clientUuid) => {
  const [demandesParRef, setDemandesParRef] = useState(new Map());

  const fetch = useCallback(async () => {
    if (!clientUuid) {
      setDemandesParRef(new Map());
      return;
    }
    try {
      const query = `?client_uuid=${clientUuid}&par_page=100`;
      const res = await financeApiService.listerDemandes(query);
      const items = (res.data?.data || []).map(
        financeV2Adapters.fromApi.demandeListItem,
      );
      setDemandesParRef(construireDemandesParDevis(items));
    } catch (err) {
      console.error("Erreur chargement des demandes par devis", err);
      setDemandesParRef(new Map());
    }
  }, [clientUuid]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { demandesParRef, refresh: fetch };
};

export default useDemandesParDevis;
